import React, { useState, useEffect, useRef } from 'react';
import { Outlet,useLocation } from "react-router-dom";
import { lang, page_url, img_url, openLink, gotoURL, gotoLink, chk_img } from './lang';
import api from './api';
import layout from '../assets/css/module/layout.module.css';
import ThemeContext from '../context/ThemeContext';
import enlogo from '../assets/video_news_01_en.jpg';
import thlogo from '../assets/video_new_01.jpg';
import footer from '../assets/footer.jpg';

export default function Layout() {
    const [search_type, setSearchType] = useState('food_name');
    const [keyword, setKeyword] = useState('');
    const [show_lang, setShowLang] = useState(false);
    const [show_lang2, setShowLang2] = useState(false);
    const [language, setLang] = useState("th");
    const [init, setInit] = useState({src:undefined});
    const [footer_th, setFooterTh] = useState("");
    const [footer_en, setFooterEn] = useState("");
    const [bg_color, setBGColor] = useState("#fff");
    const [bg_header_th, setBGHeaderTh] = useState("");
    const [bg_header_en, setBGHeaderEn] = useState("");
    const [bg_footer_th, setBGFooterTh] = useState("");
    const [bg_footer_en, setBGFooterEn] = useState("");
    const [article, setArticle] = useState([]);
    const [config, setConfig] = useState({});
    const body_ref = useRef(null);
    const lang_ref = useRef(null);
    const lang_ref2 = useRef(null);
    const location = useLocation();

    const [visitorCount, setVisitorCount] = useState([]);

    useEffect(()=>{
        if(lang==="en"){
            document.title = init.name_en;
        }else{
            document.title = init.name_th;
        }
    },[lang]);

    const fetchMenus = async () =>{
        try {
            const init_response = await api.get('/setting');
            setInit(init_response.data.results);
            let result = init_response.data.results;
            setFooterTh(result.footer_th);
            setFooterEn(result.footer_en);
            const home_config = JSON.parse(result.config);
            setBGColor(home_config.bg_color);
            setBGHeaderTh(home_config.bg_header_th);
            setBGHeaderEn(home_config.bg_header_en);
            setBGFooterTh(home_config.bg_footer_th);
            setBGFooterEn(home_config.bg_footer_en);
            document.title = result.name_th;
            document.body.style.backgroundColor = home_config.bg_color;
            // document.body.style.backgroundImage = "url('/images/th/ntic-main-background.jpg')";
            // console.log(result);

            const home_response = await api.get('/article/1');
            setArticle(home_response.data.results);
            // console.log(home_response.data.results);
            const config = JSON.parse(home_response.data.results.detail);
            setConfig(config);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    const fetchVisitor = async () => {
      try {
        let visitor = [];
      
        // const response = await api.get('/visitors');
        // let result = response.data;
        // visitor.push({
        //   total:result.today,
        //   title_th:"วันนี้",
        //   title_en:"Today"
        // }); 
        visitor.push({
        //   total:result.yesterday,
          total:1,
          title_th:"วันนี้",
          title_en:"Today"
        }); 
        visitor.push({
        //   total:result.month,
          total:10,
          title_th:"เดือนนี้",
          title_en:"This Month"
        }); 
        // visitor.push({
        // //   total:result.year,
        //   total:10,
        //   title_th:"ปีนี้",
        //   title_en:"This Year"
        // });
        visitor.push({
          //   total:result.all,
          total:10,
          title_th:"สถิติทั้งหมด",
          title_en:"All"
        }); 
        setVisitorCount(visitor);
        localStorage.setItem("visitor",JSON.stringify(visitor));
        localStorage.setItem("last_visited",new Date().toLocaleDateString());
        
      } catch (err) {
          if(err.response){
              //Not in 202 response range
              console.log(err.response.data);
              console.log(err.response.headers);
              console.log(err.response.status);
          } else {
              console.log(`Error: ${err.message}`);
          }
      }
    }

    useEffect(()=>{
          fetchMenus();
          setLang(prev => localStorage.getItem("lang"));

          let visitor=localStorage.getItem("visitor");
          // console.log(visitor);
          if(!visitor){
              fetchVisitor();
          }else{
            var todayDate = new Date().toLocaleDateString();
            let lastVisit=localStorage.getItem("last_visited");
            if(lastVisit!==todayDate){
              fetchVisitor();
            }else{
              
              setVisitorCount(JSON.parse(visitor));
            }
          }
    },[]);
    
    const handleClickOutside = (event) => {
        if (lang_ref.current && !lang_ref.current.contains(event.target)) {
            setShowLang(false);
        }
    }

    useEffect(()=>{
        if(show_lang===true){
          document.addEventListener("mousedown", handleClickOutside);
        }else{
          document.removeEventListener("mousedown", handleClickOutside);
        }
    },[show_lang]);

    const handleClickOutside2 = (event) => {
        if (lang_ref2.current && !lang_ref2.current.contains(event.target)) {
            setShowLang2(false);
        }
    }

    useEffect(()=>{
          if(show_lang===true){
            document.addEventListener("mousedown", handleClickOutside2);
          }else{
            document.removeEventListener("mousedown", handleClickOutside2);
          }
    },[show_lang2]);
    
    return (
    <ThemeContext.Provider
      value={{ language }}
    >   
    <div className={layout["page-container"]+' '+layout["popup"]} style={{backgroundImage:'url('+lang(thlogo,enlogo)+')'}}>
        <header ref={body_ref} className={layout["header"]}>
        </header>
        <main className={layout["content-box"]}>
            <article className={layout["article-box"]}>
                <Outlet />
            </article>
        </main>
        {(init)?
        <footer className={layout.footer} style={{backgroundImage:'url('+footer+')'}}>
            <div className={layout["footer-header"]}>
            </div>            
        </footer>
        :''}
    </div>
    </ThemeContext.Provider>
  )
}
